import { Billing, IBilling } from "@/models/billing.entity";
import { BackwardsCompatibleDataAccessLayer } from "@/store/backwards-compatible-paginated.store";

export const BillingDataAccessLayer = new (class extends BackwardsCompatibleDataAccessLayer<IBilling> {
  protected mapEntity(entity: IBilling): IBilling {
    return new Billing(entity);
  }
})();
